import { render, staticRenderFns } from "./fclRealList.vue?vue&type=template&id=010080a0&scoped=true&"
import script from "./fclRealList.vue?vue&type=script&lang=js&"
export * from "./fclRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010080a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010080a0')) {
      api.createRecord('010080a0', component.options)
    } else {
      api.reload('010080a0', component.options)
    }
    module.hot.accept("./fclRealList.vue?vue&type=template&id=010080a0&scoped=true&", function () {
      api.rerender('010080a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceReal/components/PriceReal/fclRealList.vue"
export default component.exports